import { useEffect, useState } from "react";
import { setDropdownValue } from "../../Store/reducers/common";
import Dropdown from "react-bootstrap/Dropdown";
import "./style.scss";

function FormSelect(props) {
  const { options, placeholder, setFieldValue, name, onChange, userStatus, value, disabled, className, dispatch, setFieldValueFull, formikRef, position } = props;
  const [selectLabel, setSelectLabel] = useState(value !== "" ? value : placeholder);
  console.log("val", value);
  useEffect(() => {
    let label = placeholder;
    if (value !== "") {
      const selected = options?.find((ele) => ele.id === value);
      if (selected) {
        label = selected.name;
      }
    }
    setSelectLabel(label);
  }, [placeholder]);

  function viewWithIcon(val) {
    return (
      <>
        <span className="inline-block mr-2 align-middle">{val.icon}</span>
        <span className="">{val.name}</span>
      </>
    );
  }

  function onChangeHandler(event) {
    if (event?.target) {
      if (onChange) {
        event.target.value = event.target.id;
        onChange(event);
      }
    }
  }

  return (
    <Dropdown
      className={`hema-form-dropdown-custom  `}
      disabled={disabled}
      onSelect={(ek, eo) => {
        onChangeHandler(eo);
      }}
      {...props}
    >
      <Dropdown.Toggle disabled={disabled} className={`hema-form-dropdown-custom ${className}`}>
        {selectLabel === "Add New Address" ? "Choose a shipping address" : selectLabel}
        {props.crossIcon && selectLabel !== "Add New Address" && (
          <p
            onClick={() => {
              formikRef?.current?.setFieldTouched(props.name, true);
              props?.setFieldValue(props.name, "");
              setSelectLabel(placeholder);
            }}
            className={`absolute top-[19px] right-[28px] cursor-pointer ${position}`}
          >
            {props.crossIcon}
          </p>
        )}
        {props.dropIcon && <span className={`absolute top-[50%] right-[10px] translate-y-[-50%] cursor-pointer`}>{props.dropIcon}</span>}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {options?.map((val) => {
          return (
            <Dropdown.Item
              key={val.id}
              id={val.id}
              name={name}
              onClick={() => {
                setSelectLabel(val.name || val.lotNumber || val.question);
                if (setFieldValue) {
                  setFieldValue(name, val.id);
                }
                if (setFieldValueFull) {
                  setFieldValueFull(name, val);
                  if (name === "sponser") {
                    const studyvalue = userStatus?.studies?.filter((study) => study.parentId === val.id)?.[0];
                    setFieldValueFull("study", studyvalue);
                    setFieldValueFull("site", userStatus?.sites?.filter((site) => site.parentId === studyvalue.id)?.[0]);
                  }
                  if (name === "study") {
                    setFieldValueFull("site", userStatus?.sites?.filter((site) => site.parentId === val.id)?.[0]);
                  }
                }
                if (dispatch) {
                  dispatch(setDropdownValue(val));
                }
              }}
            >
              {!!val.Icon && val.Icon}
              {val.icon ? viewWithIcon(val) : val.name || val.lotNumber || val.question}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default FormSelect;
